import config from "@/config"
import http from "@/utils/request"

export default {
	template: {
		index: {
			url: `${config.API_URL}/bwmall/admin/activity/coupon/template/index`,
			name: "优惠券模板",
			get: async function(data={}){
				return await http.get(this.url,data);
			}
		},
        add:{
            url: `${config.API_URL}/bwmall/admin/activity/coupon/template/add`,
			name: "添加优惠券",
			post: async function(data={}){
				return await http.post(this.url,data);
			}
        },
        modify:{
            url: `${config.API_URL}/bwmall/admin/activity/coupon/template/modify`,
			name: "变更优惠券",
			post: async function(data={}){
				return await http.post(this.url,data);
			}
        },
        del:{
            url: `${config.API_URL}/bwmall/admin/activity/coupon/template/del`,
			name: "删除优惠券",
			post: async function(data={}){
				return await http.post(this.url,data);
			}
        },
        publish:{
            url: `${config.API_URL}/bwmall/admin/activity/coupon/template/publish`,
			name: "发放优惠券",
			post: async function(data={}){
				return await http.post(this.url,data);
			}
        },
	},
    list:{
        index:{
            url: `${config.API_URL}/bwmall/admin/activity/coupon/list/index`,
			name: "优惠券列表",
			get: async function(data={}){
				return await http.get(this.url,data);
			}
        },
		getCoupon:{
            url: `${config.API_URL}/bwmall/admin.decorate/getCoupon`,
			name: "有效优惠券列表",
			get: async function(data={}){
				return await http.get(this.url,data);
			}
        },
        edit:{
            url: `${config.API_URL}/bwmall/admin/activity/coupon/list/edit`,
			name: "修改优惠券状态",
			post: async function(data={}){
				return await http.post(this.url,data);
			}
        },
        gift:{
            url: `${config.API_URL}/bwmall/admin/activity/coupon/list/gift`,
			name: "赠送优惠券",
			post: async function(data={}){
				return await http.post(this.url,data);
			}
        },
        del:{
            url: `${config.API_URL}/bwmall/admin/activity/coupon/list/del`,
			name: "删除优惠券列表",
			post: async function(data={}){
				return await http.post(this.url,data);
			}
        },
    },
    user:{
        index:{
            url: `${config.API_URL}/bwmall/admin/activity/coupon/user/index`,
			name: "发放记录",
			get: async function(data={}){
				return await http.get(this.url,data);
			}
        },
        //删除持券记录（id支持数组批量，物理删除，用于收回误发的券）
        del:{
            url: `${config.API_URL}/bwmall/admin/activity/coupon/user/del`,
			name: "删除用户优惠券",
			post: async function(data={}){
				return await http.post(this.url,data);
			}
        },
    },
    //秒杀商品
    seckill:{
        index:{
            url: `${config.API_URL}/bwmall/admin/activity/seckill/product/index`,
            name: "秒杀商品列表",
            get: async function(data={}){
                return await http.get(this.url, data);
            }
        },
        //删除秒杀商品（id支持数组批量）
        del:{
            url: `${config.API_URL}/bwmall/admin/activity/seckill/product/del`,
            name: "删除秒杀商品",
            post: async function(data={}){
                return await http.post(this.url, data);
            }
        },
        //属性修改（状态开关，字段status）
        modify:{
            url: `${config.API_URL}/bwmall/admin/activity/seckill/product/modify`,
            name: "修改秒杀商品属性",
            post: async function(data={}){
                return await http.post(this.url, data);
            }
        },
        //添加秒杀商品
        add:{
            url: `${config.API_URL}/bwmall/admin/activity/seckill/product/add`,
            name: "添加秒杀商品",
            post: async function(data={}){
                return await http.post(this.url, data);
            }
        },
        //编辑-取详情（含description）
        editGet:{
            url: `${config.API_URL}/bwmall/admin/activity/seckill/product/edit`,
            name: "秒杀商品详情",
            get: async function(data={}){
                return await http.get(this.url, data);
            }
        },
        //编辑-保存
        editPost:{
            url: `${config.API_URL}/bwmall/admin/activity/seckill/product/edit`,
            name: "编辑秒杀商品",
            post: async function(data={}){
                return await http.post(this.url, data);
            }
        },
        //秒杀规格列表（id为秒杀商品id，query传参）
        attrGet:{
            url: `${config.API_URL}/bwmall/admin/activity/seckill/product/attrList`,
            name: "秒杀规格列表",
            get: async function(id){
                return await http.get(this.url, {id: id});
            }
        },
        //秒杀规格保存
        attrPost:{
            url: `${config.API_URL}/bwmall/admin/activity/seckill/product/attrList`,
            name: "秒杀规格保存",
            post: async function(id, data={}){
                return await http.post(this.url + '?id=' + id, data);
            }
        },
    },
    //通用数据组（秒杀时间等，group_id+app由调用方指定）
    groupData:{
        //列表（分页，返回{total,list}，upload字段值为{name,size,type,src}对象）
        getConfigList:{
            url: `${config.API_URL}/manage/member/groupData/getConfigList`,
            name: "数据组列表",
            get: async function(data={}){
                return await http.get(this.url, data);
            }
        },
        //新增（query需带group_id与app）
        add:{
            url: `${config.API_URL}/manage/member/groupData/add`,
            name: "新增数据组",
            post: async function(query, data={}){
                return await http.post(this.url + query, data);
            }
        },
        //编辑-取详情（query需带id/group_id/app）
        editGet:{
            url: `${config.API_URL}/manage/member/groupData/edit`,
            name: "数据组详情",
            get: async function(data={}){
                return await http.get(this.url, data);
            }
        },
        //编辑-保存（query需带id/group_id/app）
        editPost:{
            url: `${config.API_URL}/manage/member/groupData/edit`,
            name: "编辑数据组",
            post: async function(query, data={}){
                return await http.post(this.url + query, data);
            }
        },
        //删除/批量删除（body传{ids:'1,2', app}）
        del:{
            url: `${config.API_URL}/manage/member/groupData/softdleting`,
            name: "删除数据组",
            post: async function(data={}){
                return await http.post(this.url, data);
            }
        },
        //切换状态（body传{id, app}，状态1<->2）
        setShow:{
            url: `${config.API_URL}/manage/member/groupData/setConfigShow`,
            name: "切换数据组状态",
            post: async function(data={}){
                return await http.post(this.url, data);
            }
        },
    },
    groupList:{
        index:{
            url: `${config.API_URL}/bwmall/admin/activity/combination/product/combinationList`,
			name: "拼团列表",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
        },
        //拼团用户列表（id为拼团团id）
        orderPink:{
            url: `${config.API_URL}/bwmall/admin/activity/combination/product/orderPink/`,
			name: "拼团用户",
			get: async function(id){
				return await http.get(this.url + id);
			}
        }
    },
    groupGoods:{
        index:{
            url: `${config.API_URL}/bwmall/admin/activity/combination/product/index`,
			name: "拼团商品列表",
			get: async function(data={}){
				return await http.get(this.url,data);
			}
        },
        //删除拼团商品（id支持数组批量）
        del:{
            url: `${config.API_URL}/bwmall/admin/activity/combination/product/del`,
			name: "删除拼团商品",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
        },
        //属性修改（商品状态开关等）
        modify:{
            url: `${config.API_URL}/bwmall/admin/activity/combination/product/modify`,
			name: "修改拼团商品属性",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
        },
        //添加拼团商品
        add:{
            url: `${config.API_URL}/bwmall/admin/activity/combination/product/add`,
			name: "添加拼团商品",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
        },
        //编辑-取详情
        editGet:{
            url: `${config.API_URL}/bwmall/admin/activity/combination/product/edit`,
			name: "拼团商品详情",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
        },
        //编辑-保存
        editPost:{
            url: `${config.API_URL}/bwmall/admin/activity/combination/product/edit`,
			name: "编辑拼团商品",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
        },
        //规格列表（id为拼团商品id，后端路由无路径参数，id走query传递）
        attrGet:{
            url: `${config.API_URL}/bwmall/admin/activity/combination/product/attrList`,
			name: "拼团规格列表",
			get: async function(id){
				return await http.get(this.url, {id: id});
			}
        },
        //规格保存
        attrPost:{
            url: `${config.API_URL}/bwmall/admin/activity/combination/product/attrList`,
			name: "拼团规格保存",
			post: async function(id, data={}){
				return await http.post(this.url + '?id=' + id, data);
			}
        },
        //选择商品列表（layui格式返回 code:0/count/data）
        productList:{
            url: `${config.API_URL}/bwmall/admin/activity/productList`,
			name: "商品列表",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
        },
        //运费模板列表
        templateList:{
            url: `${config.API_URL}/bwmall/admin/template/index`,
			name: "运费模板列表",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
        },
        showMemberConfig:{
            url: `${config.API_URL}/manage/member/config/showMemberConfig`,
			name: "拼团商品列表",
			get: async function(data={}){
				return await http.get(this.url,data);
			}
        }
    },
    //砍价商品（新增/编辑/规格/上下架/删除/导出）
    bargainGoods:{
        index:{
            url: `${config.API_URL}/bwmall/admin/activity/bargain/product/index`,
			name: "砍价商品列表",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
        },
        del:{
            url: `${config.API_URL}/bwmall/admin/activity/bargain/product/del`,
			name: "删除砍价商品",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
        },
        modify:{
            url: `${config.API_URL}/bwmall/admin/activity/bargain/product/modify`,
			name: "修改砍价商品属性",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
        },
        add:{
            url: `${config.API_URL}/bwmall/admin/activity/bargain/product/add`,
			name: "添加砍价商品",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
        },
        editGet:{
            url: `${config.API_URL}/bwmall/admin/activity/bargain/product/edit`,
			name: "砍价商品详情",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
        },
        editPost:{
            url: `${config.API_URL}/bwmall/admin/activity/bargain/product/edit`,
			name: "编辑砍价商品",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
        },
        attrGet:{
            url: `${config.API_URL}/bwmall/admin/activity/bargain/product/attrList`,
			name: "砍价规格列表",
			get: async function(id){
				return await http.get(this.url, {id: id});
			}
        },
        attrPost:{
            url: `${config.API_URL}/bwmall/admin/activity/bargain/product/attrList`,
			name: "砍价规格保存",
			post: async function(id, data={}){
				return await http.post(this.url + '?id=' + id, data);
			}
        },
        //导出砍价商品CSV（blob流下载，接口需token故走http封装）
        export:{
            url: `${config.API_URL}/bwmall/admin/activity/bargain/product/export`,
			name: "导出砍价商品",
			get: async function(data={}, config={}){
				return await http.get(this.url, data, config);
			}
        }
    },
    //砍价列表（参与记录 + 帮砍明细）
    bargainList:{
        index:{
            url: `${config.API_URL}/bwmall/admin/activity/bargain/product/bargainList`,
			name: "砍价参与列表",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
        },
        helpList:{
            url: `${config.API_URL}/bwmall/admin/activity/bargain/product/helpList/`,
			name: "帮砍明细",
			get: async function(id){
				return await http.get(this.url + id);
			}
        }
    },
    //砍价统计（头部指标 + 发起明细 + 活动订单）
    bargainStatistics:{
        head:{
            url: `${config.API_URL}/bwmall/admin/activity/bargain/product/statistics/head/`,
			name: "砍价统计指标",
			get: async function(id){
				return await http.get(this.url + id);
			}
        },
        list:{
            url: `${config.API_URL}/bwmall/admin/activity/bargain/product/statistics/list/`,
			name: "砍价发起明细",
			get: async function(id, data={}){
				return await http.get(this.url + id, data);
			}
        },
        order:{
            url: `${config.API_URL}/bwmall/admin/activity/bargain/product/statistics/order/`,
			name: "砍价活动订单",
			get: async function(id, data={}){
				return await http.get(this.url + id, data);
			}
        }
    }
}
